import { render, staticRenderFns } from "./CurrentJobOrRole.vue?vue&type=template&id=a9d79c6c&scoped=true&"
import script from "./CurrentJobOrRole.vue?vue&type=script&lang=js&"
export * from "./CurrentJobOrRole.vue?vue&type=script&lang=js&"
import style0 from "./CurrentJobOrRole.vue?vue&type=style&index=0&id=a9d79c6c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d79c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
